module.exports = __webpack_public_path__ + "static/media/check.5d623a31.svg";